<template>
    <div>
        <div class="flex" @click="onClickShowRedeem()" :class="[ isExpired ?'opacity-50':'']">
            <div class="flex-initial">
                <div class="w-36">
                    <img class="w-full" :src="purchase.fullImageUrl" :class="[!isShowRedeem ? 'opacity-60 text-tc-gray-3' : '']">
                </div>
            </div>
            <div class="pl-5 flex-grow">
                <div class="text-20 text-tc-blue-2" :class="[!isShowRedeem ? 'text-opacity-60' : '']">{{ FiltertDateFormatShortMonthWithTime(purchase.redeemDate) }}</div>
                <div class="text-22 text-2-line text-tc-gray-3 font-main-medium" :class="[!isShowRedeem ? 'text-opacity-60 text-tc-gray-3' : '']">{{ purchase.name }}</div>
                 
                <div class="flex items-center gap-1 " v-if="(isShipped || isShowDelivery) && purchase.parcelNo">
                    <span class="text-20 text-tc-gray-3">{{lbl.purchase.parcelNo}} : </span><span class="text-20 text-a-blue-1c3e95 font-medium">{{purchase.parcelNo || "-"}}</span>
                    <div class="cursor-pointer parcelNo" v-clipboard:copy="purchase.parcelNo">
                        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M13.2739 3.42188H0.898926C0.762174 3.42188 0.631022 3.4762 0.534324 3.5729C0.437625 3.6696 0.383301 3.80075 0.383301 3.9375V16.3125C0.383301 16.4493 0.437625 16.5804 0.534324 16.6771C0.631022 16.7738 0.762174 16.8281 0.898926 16.8281H13.2739C13.4107 16.8281 13.5418 16.7738 13.6385 16.6771C13.7352 16.5804 13.7896 16.4493 13.7896 16.3125V3.9375C13.7896 3.80075 13.7352 3.6696 13.6385 3.5729C13.5418 3.4762 13.4107 3.42188 13.2739 3.42188ZM12.7583 15.7969H1.41455V4.45312H12.7583V15.7969ZM16.5396 1.1875V13.5625C16.5396 13.6993 16.4852 13.8304 16.3885 13.9271C16.2918 14.0238 16.1607 14.0781 16.0239 14.0781C15.8872 14.0781 15.756 14.0238 15.6593 13.9271C15.5626 13.8304 15.5083 13.6993 15.5083 13.5625V1.70312H3.64893C3.51217 1.70312 3.38102 1.6488 3.28432 1.5521C3.18763 1.4554 3.1333 1.32425 3.1333 1.1875C3.1333 1.05075 3.18763 0.919596 3.28432 0.822898C3.38102 0.7262 3.51217 0.671875 3.64893 0.671875H16.0239C16.1607 0.671875 16.2918 0.7262 16.3885 0.822898C16.4852 0.919596 16.5396 1.05075 16.5396 1.1875Z" fill="#1C3E95"/>
                        </svg> 
                    </div>
                </div>
                <div v-if="isShowDelivery" class="deliveryMessage text-20 text-tc-gray-3">{{lbl.purchase.status}} : <span class="font-medium" :class=[statusDelevery()]>{{deliveryMessage}}</span></div>
               
                <div class="flex items-center">
                    <div class="text-20 text-tc-orange-1 font-main-medium" :class="[!isShowRedeem ? 'text-opacity-60 text-tc-gray-3' : '']">
                        <span v-if="purchase.pointPerUnit > 0">-</span>
                        
                        <span class="campaign-baht" v-if="isShowBaht">
                            ฿{{ FilterNumberFormat(purchase.maximumPartialPrice) }} + {{FilterNumberFormat(purchase.maximumPartialPoints ?? 0)}}
                        </span>
                        <span class="campaign-baht" v-if="!isShowBaht"> 
                            {{FilterNumberFormat(purchase.pointPerUnit ?? 0)}}
                        </span> 
                        <img class="mx-1 w-4 inline-block" src="@/assets/icon/coin-point.png">
                    </div>
                    <div class="text-right flex-grow text-18" v-if="isShowReddemBtn && !isShowDelivery && !isPrivilegeAndUsed">
                        <span v-if="isShowRedeem" class="text-tc-blue-2 underline cursor-pointer" @click="onClickShowRedeem()">
                            {{lbl.history.show_code}}
                        </span>
                        <span v-else class="text-opacity-60 text-tc-gray-3">{{lbl.history.expire}}</span>
                    </div>
                    <!-- <span v-if="isUsed" class="text-right flex-grow text-18 text-tc-gray-3">{{lbl.serial.isUsed}}</span> -->
                    <span v-if="isExpired" class="text-right flex-grow text-18 text-tc-gray-3">{{lbl.serial.isExpired}}</span>
               
                </div>
            </div>
        </div>
        <div class="line my-10px bg-tc-gray-4"></div>
    </div>
</template>

<script>
import { CampaignType } from '@/helper/StaticValue'
import LocaleMixin from '@/mixin/LocaleMixin';
export default {
    name: 'HistoryRedeemUse',
    mixins: [LocaleMixin],
    props:{
        campaign: Object
    },
    data() {
        return {
            purchase:null,
            isShipped:false,
            deliveryMessage:'',
            isShowDelivery:false,
            currntTimeStamp: Math.ceil(new Date().getTime()/1000),
        }
    },
    computed:{ 
        isPrivilegeAndUsed: function () {
            return (this.purchase.type == CampaignType.Privilege20 && this.purchase.isUsed);
        },
        isShowBaht: function () {
            return (this.purchase.type == CampaignType.Privilege20);
        },
        isShowRedeem:function(){
            if( this.purchase.expireIn && this.purchase.expireIn < 0){
                return false
            }
            else if(this.purchase.website && this.purchase.website.indexOf('wondd') >= 0){
                return false
            }
            return true
        },  
        isUsed:function(){
            return this.purchase.isUsed
        },
        isShowReddemBtn: function(){
            return this.purchase.type !== CampaignType.Interface &&
                    this.purchase.type !== CampaignType.News
        },
        isExpired: function(){
            return this.purchase.voucherExpireDate  && this.purchase.voucherExpireDate < this.currntTimeStamp
        }
    },
    created: function(){
        this.purchase = this.campaign;
        //console.log(this.purchase)
        //this.purchase.parcelNo = "1234567890";
        this.handleDelivery() 
    },
    methods: {
        statusDelevery: function(){
            if(this.isFailDelevery()){
                return 'text-a-red-FF1400'
            } 
            else if(this.purchase.type === CampaignType.Privilege20){
                if (this.purchase.isShipped && this.purchase.parcelNo) { 
                    return "text-a-green-01AD46";
                }else if (!this.purchase.isShipped && this.purchase.parcelNo) { 
                    return "text-a-orange-FA9601"
                } else {
                    return "text-a-orange-FA9601"
                }
            }else{
                if (this.purchase.isShipped) {
                    return "text-a-green-01AD46";
                } else {
                    return "text-a-orange-FA9601"
                }
            } 
        },
        handleDelivery: function(){
            //delivery.
            if (this.purchase.delivered === true) {
                this.isShowDelivery = true;
                if (this.purchase.type === CampaignType.Draw) {
                    if (!this.purchase.hasWinner) {
                        this.isShowDelivery = false;
                    } else {
                        if (!this.purchase.isWinner)
                            this.isShowDelivery = false;
                    }
                }

                //update privilege 2.0
                if (this.isFailDelevery()) {
                    this.isShipped = true;
                    this.deliveryMessage = this.lbl.purchase.privilege_shipped_fail;
                }
                else if(this.purchase.type === CampaignType.Privilege20){
                    if (this.purchase.isShipped && this.purchase.parcelNo) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lbl.purchase.privilege_shipped;
                    }else if (!this.purchase.isShipped && this.purchase.parcelNo) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lbl.purchase.privilege_delivery;
                    } else {
                        this.isShipped = false;
                        this.deliveryMessage = this.lbl.purchase.privilege_prepare;
                    }
                }else{
                    if (this.purchase.isShipped) {
                        this.isShipped = true;
                        this.deliveryMessage = this.lbl.purchase.shipped;
                    } else {
                        this.isShipped = false;
                        this.deliveryMessage = this.lbl.purchase.delivery;
                    }
                } 
            }
        },
        isFailDelevery: function() {
            if (this.purchase.shippedStatus && 
                (this.purchase.shippedStatus.indexOf("Fail") != -1 || this.purchase.shippedStatus.indexOf("fail") != -1)) {
                return true;
            }
            return false;
        },
        onClickShowRedeem:function(){
            // console.log(this.purchase)
            if(!this.isShowRedeem) return;
            if(this.isShowDelivery) return;
            if(this.purchase.type === CampaignType.Privilege20){ 
                if(this.isUsed) return;
            }
            if(this.isExpired) return;
            this.$emit('onClick',this.purchase)
        }
    },
};
</script>

<style lang="scss" scoped>
.line{
    height: 0.5px;
    transform: rotate(-180deg);
}
 
</style>
